"use client";
import { j as o } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as g } from "./tv.config-BuYIgndg.mjs";
import * as a from "react";
import { useId as y } from "react";
import { r as N } from "./Field.style-CQ8CRW6E.mjs";
import { C as R } from "./check-BIIp9_Zd.mjs";
import { F as j, b as M, a as S } from "./FieldDescription-LT07Zs4i.mjs";
import { F as I } from "./FieldLabel-C2NVcnds.mjs";
import { u as v, a as F, C as E } from "./CheckboxRoot-VdDogCRp.mjs";
import { u as H } from "./useRenderElement-B8V3_e8R.mjs";
import { u as z, a as D } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { t as L } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { f as O } from "./FieldRootContext-Cj7-dNhd.mjs";
const x = /* @__PURE__ */ a.forwardRef(function(s, n) {
  const {
    render: r,
    className: m,
    keepMounted: c = !1,
    ...i
  } = s, e = v(), t = e.checked || e.indeterminate, {
    transitionStatus: d,
    setMounted: b
  } = z(t), p = a.useRef(null), h = a.useMemo(() => ({
    ...e,
    transitionStatus: d
  }), [e, d]);
  D({
    open: t,
    ref: p,
    onComplete() {
      t || b(!1);
    }
  });
  const u = F(e), k = a.useMemo(() => ({
    ...u,
    ...L,
    ...O
  }), [u]), f = c || t, C = H("span", s, {
    enabled: f,
    ref: [n, p],
    state: h,
    customStyleHookMapping: k,
    props: i
  });
  return f ? C : null;
});
process.env.NODE_ENV !== "production" && (x.displayName = "CheckboxIndicator");
const V = g({
  slots: {
    root: [
      "flex size-5 items-center justify-center rounded-md outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-main data- border data-[checked]:border-primary-main data-[checked]:bg-primary-main  data-[unchecked]:border-gray-300 flex-shrink-0"
    ],
    label: [
      "inline-flex items-center gap-2 text-base text-gray-900 cursor-pointer select-none"
    ],
    indicator: "flex text-gray-50 data-[unchecked]:hidden",
    icon: "size-5"
  },
  variants: {
    colSpan: {
      1: {
        root: ["col-span-1"]
      },
      2: {
        root: ["col-span-1 sm:col-span-2"]
      },
      3: {
        root: ["col-span-1 sm:col-span-3"]
      },
      4: {
        root: ["col-span-1 sm:col-span-4"]
      },
      5: {
        root: ["col-span-1 sm:col-span-5"]
      },
      6: {
        root: ["col-span-1 sm:col-span-6"]
      }
    }
  }
}), {
  root: w,
  label: B,
  indicator: T,
  icon: _
} = V(), $ = (l) => {
  const { label: s, id: n, className: r, colSpan: m, ...c } = l, i = y(), e = n ?? i;
  return /* @__PURE__ */ o.jsxs(
    j,
    {
      className: N({
        colSpan: m,
        className: typeof r == "string" ? r : ""
      }),
      children: [
        /* @__PURE__ */ o.jsxs(I, { className: B(), children: [
          /* @__PURE__ */ o.jsx(
            E,
            {
              ...c,
              className: w(),
              id: e,
              children: /* @__PURE__ */ o.jsx(x, { className: T(), children: /* @__PURE__ */ o.jsx(R, { className: _() }) })
            }
          ),
          s
        ] }),
        /* @__PURE__ */ o.jsx(M, {}),
        /* @__PURE__ */ o.jsx(S, {})
      ]
    }
  );
};
export {
  $ as default
};
